import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router";
function Index() {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>نیکوتن | قراردادها </title>
        <meta name="description" content={"قراردادها"} />
      </Helmet>
      <div
        style={{ height: "100vh", width: "100vw" }}
        className="d-flex align-items-center justify-content-center "
      >
        <div className="menucontract">
          <div className="logobar">
            <div>
              <img
                src={window.location.origin + "/img/logo/logo2.png"}
                width={"80px"}
                height={"80px"}
              />
            </div>
            <div className="mt-1">
              <h6>نیکوتن</h6>
              <h6>سامانه رزرو آنلاین ورزشی</h6>
            </div>
          </div>
          <div className="row justify-content-evenly mt-4">
            <div className="col d-flex justify-content-center align-items-center">
              <button
                className="btn"
                style={{
                  backgroundColor: "rgb(228, 42, 63)",
                  color: "#fff",
                }}
                onClick={() => {
                  navigate("/contract/tracking");
                }}
              >
                پیگیری قرارداد
              </button>
            </div>
            <div className="col  d-flex justify-content-center align-items-center">
              <button
                className="btn"
                style={{
                  backgroundColor: "rgb(30, 140, 59)",
                  color: "#fff",
                }}
                onClick={() => {
                  navigate("/contract/new");
                }}
              >
                ثبت قراداد
              </button>
            </div>
          </div>
          <div className="mt-4 menu-textbox">
            <h6>
              اگر قبلا قرارداد خود را ثبت کرده اید لطفا منتظر تایید مدیریت
              باشید.
            </h6>
            <h6>از ارسال قراداد تکراری خودداری کنید.</h6>
            <h6>پشتیبانی : 02191027127</h6>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
